import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { API_HOST } from "environments/environment";

@Injectable({
    providedIn: 'root'
})
export class DocumentMgmtApiService {

    /** Emit to notify subscribers (e.g. notification bell) that a document was updated */
    public documentUpdated$ = new Subject<void>();

    constructor(private http: HttpClient) { }

    public get() {
        return this.http.get(API_HOST + 'management/document-mgmt');
    }

    public create(data: any) {
        return this.http.post(API_HOST + 'management/document-mgmt', data);
    }

    public update(id: string, data: any) {
        return this.http.put(API_HOST + `management/document-mgmt/${id}`, data);
    }

    public delete(id: string) {
        return this.http.delete(API_HOST + `management/document-mgmt/${id}`);
    }

    public uploadAttachment(documentId: string, file: File) {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post(API_HOST + `management/document-mgmt/${documentId}/attachments`, formData);
    }

    public deleteAttachment(documentId: string, attachmentIndex: number) {
        return this.http.delete(API_HOST + `management/document-mgmt/${documentId}/attachments/${attachmentIndex}`);
    }

    public confirmUpdate(id: string) {
        return this.http.put(API_HOST + `management/document-mgmt/${id}/confirm-update`, {});
    }
}
